export function SET_ROLES (state, data) {
    state.roles = data.roles
}